import {
  Tabs as ChakraTabs,
  TabsContentProps,
  TabsListProps,
  TabsRootProps,
  TabsTriggerProps,
} from '@chakra-ui/react'
import { MouseEventHandler, ReactNode } from 'react'

export interface Props extends Omit<TabsRootProps, 'children'> {
  items: TabContent[]
  tabListProps?: Omit<TabsListProps, 'children'>
}

export interface TabContent extends Omit<TabsContentProps, 'value' | 'onClick'> {
  value?: string
  label: ReactNode
  labelProps?: Omit<TabsTriggerProps, 'children' | 'value'>
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export default function Tabs({ items, tabListProps, ...rest }: Props) {
  return (
    <ChakraTabs.Root lazyMount {...rest}>
      <ChakraTabs.List
        colorPalette={{ base: 'primary', _dark: 'white' }}
        flexShrink={0}
        {...tabListProps}
      >
        {items.map(({ label, labelProps, value, onClick }, index) => (
          <ChakraTabs.Trigger
            fontWeight="normal"
            height="auto"
            key={value ?? index}
            onClick={onClick}
            p={4}
            textStyle="bodyMedium"
            value={value || index.toString()}
            {...labelProps}
          >
            {label}
          </ChakraTabs.Trigger>
        ))}
      </ChakraTabs.List>

      {items.map(({ value, label, labelProps, onClick, ...rest }, index) => (
        <ChakraTabs.Content
          mt={4}
          key={value ?? index}
          value={value || index.toString()}
          p={0}
          {...rest}
        />
      ))}
    </ChakraTabs.Root>
  )
}
